<button class="btn btn-danger" (click)="logout()">
    <i class="fas fa-sign-out-alt" #icon></i> <span class="element-text">{{ 'logout' | translate }}</span>
</button>